<template>
  <public-layout>
    <div class="row">
      <!-- Image / info section -->
      <aside class="img-holder" aria-label="Branding and information">
        <div class="arrow-left" aria-hidden="true"></div>
        <div class="bg" aria-hidden="true"></div>

        <div class="info-holder">
          <a href="/" aria-label="Go to homepage">
            <img class="login-logo" :src="require('@/assets/images/roiq_light.png')" alt="Roiq Logo">
          </a>
          <h2 class="sub-title"><strong>Activate AI</strong> For All</h2>
        </div>

        <p class="login-disclaimer">
          As a DealerX partner/client, I acknowledge that in using the RoiQ   platform; I and/or my dealership/vendor staff are accessing data directly from DealerX servers and cloud instances domiciled in Florida. I also acknowledge that I and/or my dealership/vendor staff is also leveraging peer-to-peer data connections from DealerX personnel whose devices are domiciled in Florida.
        </p>
      </aside>

      <!-- Form section -->
      <main class="form-holder" role="main">
        <section class="form-content" aria-labelledby="forgot-password-heading">
          <h1 id="forgot-password-heading" class="sr-only">Reset Password</h1>

          <!-- Loader / animation -->
          <div class="loader" aria-hidden="true">
            <div class="row h-100">
              <div class="col-4 my-auto">
                <div class="px-0 py-3">
                  <img :src="require('@/assets/images/roiq-loader-light.gif')" alt="Loading animation">
                </div>
              </div>
              <div class="col-8 my-auto px-0">
                <div class="logo-text">
                  <img :src="require('@/assets/images/loading2.png')" alt="Loading">
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile logo / heading -->
          <div class="mob-logo">
            <img :src="require('@/assets/images/roiq_light.png')" alt="Roiq Logo">
            <h2>Activate AI For All</h2>
          </div>

          <!-- Form -->
          <v-card class="transparent-card">
            <v-card-title>
              <h1>404 - Page Not Found</h1>
            </v-card-title>
            <v-card-text>
              <h3>The page you are looking for does not exist.</h3>
            </v-card-text>
          </v-card>
        </section>
      </main>
    </div>
  </public-layout>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>

<style lang="scss" scoped>
@import url('@/assets/scss/auth.scss');

.transparent-card {
  background: transparent !important;
  box-shadow: none !important;
  color: #fff !important;
}
</style>